import { buildBreadcrumb } from '../lib/breadcrumbFormat';
import { TIKTOK_POST_COLUMN_SPEC, buildPostCards } from '../lib/postCards';
import { buildColumns, parentName } from '../lib/tableHelpers';
import InlinePostGrid, {
    type PostGridModel,
} from '../primitives/InlinePostGrid';
import type { VisualProps, VisualWidget } from '../types';

const TYPE_LABEL = 'Post';

function buildPostsModel({ input, output }: VisualProps): PostGridModel {
    // Prefer the backend-resolved sort; drives the bolded header column and the
    // card's first metric row.
    const orderBy = output?.result?.order_by ?? input?.order_by;
    // The volume column (Views: Last Week) is always shown; the sort key adds a
    // second column carrying that metric — by default Avg Weekly Views ("last
    // month"). Only the WoW growth fallback (sort == the volume column) is filtered
    // out, so those cases show a single Views column.
    const columns = buildColumns(orderBy, TIKTOK_POST_COLUMN_SPEC).filter(
        (col) => col.isSort || !col.isGrowth,
    );
    return {
        breadcrumb: buildBreadcrumb(output, TYPE_LABEL),
        title: { parent: parentName(output), noun: 'posts' },
        link: output?.result?.dashboard_url,
        columns,
        cards: buildPostCards(output, columns),
    };
}

const PostsInlineList = ({ Frame, ...props }: VisualProps) => (
    <InlinePostGrid {...buildPostsModel(props)} Frame={Frame} />
);

const widget: VisualWidget = {
    match: (input) =>
        input?.data_source === 'tiktok' &&
        input?.entity_relationship === 'posts',
    Component: PostsInlineList,
};

export default widget;
